import { render, staticRenderFns } from "./employeesInfo.vue?vue&type=template&id=639108fb&"
import script from "./employeesInfo.vue?vue&type=script&lang=js&"
export * from "./employeesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports